import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "./../api";
import { Link } from "react-router-dom";

const OrdersList = () => {
  const [paniers, setPaniers] = useState([]);
  const [search, setSearch] = useState("");
  const [etatFilter, setEtatFilter] = useState("");
  const [livraisonFilter, setLivraisonFilter] = useState("");
  const [loading, setLoading] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const token = localStorage.getItem("authToken");
  const axiosConfig = {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  };

  // Charger tous les paniers
  const fetchPaniers = async () => {
    try {
      setLoading(true);
      const res = await API.get("/panier/getPanier", axiosConfig);
      const data = Array.isArray(res.data) ? res.data : [];
      setPaniers(data);
    } catch (err) {
      console.error("Erreur fetch paniers:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPaniers();
  }, []);

  // Filtrage combiné
  const filteredPaniers = paniers.filter((p) => {
    const client = p.Client || {};
    const term = search.toLowerCase();

    const matchSearch =
      !term ||
      client.nom?.toLowerCase().includes(term) ||
      client.prenom?.toLowerCase().includes(term) ||
      client.email?.toLowerCase().includes(term);

    const matchEtat = etatFilter === "" || p.etat === Number(etatFilter);
    const matchLivraison =
      livraisonFilter === "" || p.livre === Number(livraisonFilter);

    return matchSearch && matchEtat && matchLivraison;
  });

  const totalPages = Math.ceil(filteredPaniers.length / itemsPerPage);
  const startIdx = (currentPage - 1) * itemsPerPage;
  const displayed = filteredPaniers.slice(startIdx, startIdx + itemsPerPage);

  const terminerPanier = async (id_panier) => {
    if (!window.confirm("Confirmer la terminaison du panier ?")) return;
    try {
      await API.put(`/panier/validerFin/${id_panier}`, {}, axiosConfig);
      await fetchPaniers();
      alert("Panier marqué comme terminé !");
    } catch (err) {
      console.error("Erreur terminerPanier:", err);
      alert("Erreur : " + (err.response?.data?.message || err.message));
    }
  };

  return (
    <div className="container py-4">
      <h2>Liste des commandes</h2>

      {/* Filtres */}
      <div className="d-flex flex-wrap gap-3 align-items-center mb-3">
        <input
          type="text"
          className="form-control w-auto flex-grow-1"
          placeholder="Rechercher par nom, prénom ou email..."
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setCurrentPage(1);
          }}
        />
        <select
          className="form-select w-auto"
          value={etatFilter}
          onChange={(e) => setEtatFilter(e.target.value)}
        >
          <option value="">Tous les états</option>
          <option value="0">En attente</option>
          <option value="1">En cours</option>
          <option value="2">Terminé</option>
        </select>
        <select
          className="form-select w-auto"
          value={livraisonFilter}
          onChange={(e) => setLivraisonFilter(e.target.value)}
        >
          <option value="">Toutes livraisons</option>
          <option value="0">Non livré</option>
          <option value="1">En cours</option>
          <option value="2">Livré</option>
        </select>
        <button className="btn btn-outline-secondary" onClick={fetchPaniers}>
          🔄 Rafraîchir
        </button>
      </div>

      {/* Tableau */}
      <div className="card">
        <div className="card-header">
          <strong>Commandes ({filteredPaniers.length})</strong>
        </div>
        <div className="card-body table-responsive">
          {loading ? (
            <div>Chargement...</div>
          ) : (
            <table className="table table-striped table-hover align-middle">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Client</th>
                  <th>Email</th>
                  <th>Valeur</th>
                  <th>État</th>
                  <th>Livraison</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {displayed.map((p) => (
                  <tr key={p.id_panier}>
                    <td>{p.id_panier}</td>
                    <td>
                      {p.Client ? `${p.Client.nom} ${p.Client.prenom}` : "—"}
                    </td>
                    <td>{p.Client?.email || "—"}</td>
                    <td>{p.valeur?.toLocaleString()} FCFA</td>
                    <td>
                      {p.etat === 0
                        ? "En attente"
                        : p.etat === 1
                        ? "En cours"
                        : "Terminé"}
                    </td>
                    <td>
                      {p.livre === 0
                        ? "Non livré"
                        : p.livre === 1
                        ? "En cours"
                        : "Livré"}
                    </td>
                    <td>
                      {p.etat === 1 ? (
                        <button
                          className="btn btn-sm btn-success me-1"
                          onClick={() => terminerPanier(p.id_panier)}
                        >
                          Terminer
                        </button>
                      ) : (
                        <button
                          className="btn btn-sm btn-outline-secondary me-1"
                          disabled
                        >
                          Terminer
                        </button>
                      )}
                      <Link
                        to={`/order/${p.id_panier}`}
                        className="btn btn-sm btn-outline-primary"
                      >
                        Détails
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            ⬅ Précédent
          </button>
          <span>
            Page {currentPage} / {totalPages}
          </span>
          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Suivant ➡
          </button>
        </div>
      )}
    </div>
  );
};

export default OrdersList;
